import alert from 'sweetalert2';




export  function Alerta(wtitle,wtext,wicon){
    alert.fire({
      title:wtitle,
      text:wtext,
      icon:wicon
    })  
  }


  export function PerguntaModal({ pergunta, onResposta, onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-content">
          <p>{pergunta}</p>
          <div className="modal-buttons">
            <button onClick={() => onResposta(true)}>Sim</button>
            <button onClick={() => onResposta(false)}>Não</button>
            <button onClick={onClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}


 